import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import { changeAntdTheme } from "mini-dynamic-antd-theme";
import PropTypes from "prop-types";

import {
  DARK_COLORS,
  generateColors,
  generateDarkColors,
  LIGHT_COLORS,
} from "../Utils/colors";

const ThemeContext = createContext({
  COLORS: LIGHT_COLORS,
  updateColors: () => {},
});

export const useAppTheme = () => useContext(ThemeContext);

const ThemeProvider = ({ children }) => {
  const [colors, setColors] = useState(LIGHT_COLORS);

  const updateColors = (newColors, theme = "light") => {
    let themeColors = { ...LIGHT_COLORS };
    const colorValues = {
      primary: newColors.PRIMARY || colors.PRIMARY,
      secondary: newColors.SECONDARY || colors.SECONDARY,
      info: newColors.INFO || colors.INFO,
      success: newColors.SUCCESS || colors.SUCCESS,
      warning: newColors.WARNING || colors.WARNING,
      error: newColors.ERROR || colors.ERROR,
    };

    let updatedColors = {
      ...themeColors,
      ...generateColors(colorValues),
      ...newColors,
    };

    if (theme === "dark") {
      themeColors = { ...DARK_COLORS };
      updatedColors = {
        ...themeColors,
        ...generateDarkColors(colorValues),
        ...newColors,
      };
    }

    setColors({ ...updatedColors });
  };

  useEffect(() => {
    Object.keys(colors).forEach((key) => {
      document.documentElement.style.setProperty(
        `--${key.toLowerCase().replace(/_/g, "-")}`,
        colors[key]
      );
    });

    if (colors.PRIMARY) {
      changeAntdTheme(colors.PRIMARY);
    }
  }, [colors]);

  const themeValues = useMemo(
    () => ({
      COLORS: colors,
      updateColors,
    }),
    [colors]
  );

  return (
    <ThemeContext.Provider value={themeValues}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
